<template>
  <v-row v-if="lodash.isEmpty(medicalReports)" justify="center">
    <v-col cols="6">
      <v-alert color="orange" outlined text type="info">
        Não há relatórios
      </v-alert>
    </v-col>
  </v-row>

  <v-row v-else dense>
    <v-col>
      <v-row
        dense
        v-for="(medicalReport, index) in medicalReports"
        :key="medicalReport.id"
      >
        <v-col>
          <medicalReportListItem
            :attendance="attendance"
            :medicalReport="medicalReport"
            :index="index"
            :refreshList="refreshList"
            :allowEdit="allowEdit"
            :allowDelete="allowDelete"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import medicalReportListItem from "@/components/medical_record/medical_report/list/item.vue";

export default {
  name: "MedicalReportList",
  props: {
    attendance: Object,
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    medicalReportListItem,
  },
  mounted() {
    this.refreshList();
  },
  apollo: {
    medicalReports: {
      query: require("@/graphql/medical_report/medical_reports.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      update(data) {
        return this.lodash.orderBy(data.medicalReports, ["createdAt"], ["asc"]);
      },
      pollInterval: 20000,
    },
  },
  methods: {
    async refreshList() {
      await this.$apollo.queries.medicalReports.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
